























































































    import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
    import TablePager from '@/components/TablePager.vue';
    import TableField from '@/types/TableField';
    import TableSortEventArgs from '@/types/TableSortEventArgs';
    import PagerOptions, { InitPagerOptions } from '@/types/PagerOptions';
    import SortOptions from '@/types/SortOptions';
    import EntityReference from '@/types/EntityReference';
    import { BTable, BButton, BIconArrowUp, BIconArrowDown, BCard, BCardHeader, BCardBody, BCollapse, BRow, BCol, BSpinner } from 'bootstrap-vue';
    import TaskFilterOptions from '@/types/TaskFilterOptions';
    import Configuration from '@/types/Configuration';
    import InlineSvg from 'vue-inline-svg';
    import ColumnHeader from '@/components/ColumnHeader.vue';
    import AxiosService from '@/services/axiosService';
    import i18n from '../i18n';
    import Authorization, { PermissionScope } from '../types/Authorization';

    @Component({
        components: {
            'table-pager': TablePager,
            'b-table': BTable,
            'b-card': BCard,
            'b-card-header': BCardHeader,
            'b-card-body': BCardBody,
            'b-collapse': BCollapse,
            'b-row': BRow,
            'b-col': BCol,
            'b-btn': BButton,
            'b-icon-arrow-up': BIconArrowUp,
            'b-icon-arrow-down': BIconArrowDown,
            'inline-svg': InlineSvg,
            'column-header': ColumnHeader,
            'b-spinner': BSpinner
        }
    })
	export default class TaskList extends Vue {
        @Prop() refresh!: boolean
        @Prop() filter!: TaskFilterOptions

        tasks: TaskListItem[] = [];
        listOptions: TaskListOptions = {
            filter: this.filter,
            pagerOptions: {
                page: 1,
                pageSize: Configuration.DefaultPageSize,
                pageCount: 1,
                rowCount: 0,
                rowStart: 0,
                rowEnd: 0
            },
            sortOptions: {
                sortBy: 'sequenceId',
                sortDirection: Configuration.SortDirectionAscending
            }
        };
        isBusy = false;
        apiAccessToken = this.$store.state.apiAccessToken;
        fields: TableField[] = [];

        @Watch('refresh')
        refreshList(newVal: boolean) {
            if (newVal) {
                this.loadTasks();
            }
        }

        @Watch('filter')
        filterList(newVal: TaskFilterOptions) {
            this.listOptions.filter = newVal;
            this.listOptions.pagerOptions.page = 1;
        }

        canEditTask(projectId: string) {
            return Authorization.checkAccessRights(this.$appUser, Authorization.operations.editTask, projectId, PermissionScope.Project);
        }

        mounted() {
            this.isBusy = false;
            this.initFields();
            this.apiAccessToken = this.$store.state.apiAccessToken;
            this.loadTasks();
            this.$root.$on('LocaleChanged', this.onLocaleChanged);
        }

        unmounted() {
            this.$root.$off('LocaleChanged');
        }

        initFields() {
            this.fields = [
                {
                    key: 'sequenceId',
                    label: this.$t('fields.id').toString(),
                    headerTitle: 'Id',
                    sortable: true,
                    thStyle: 'width: 75px',
                    thClass: 'unselectable text-nowrap columnheader',
                    tdClass: 'text-nowrap datatable-cell text-dark-75 font-size-lg font-weight-bolder py-2',
                    formatter: null
                },
                {
                    key: 'name',
                    label: this.$t('fields.name').toString(),
                    headerTitle: 'Name',
                    sortable: true,
                    thStyle: '',
                    thClass: 'unselectable text-nowrap columnheader',
                    tdClass: 'datatable-cell text-dark-75 font-size-lg font-weight-bolder py-2',
                    formatter: null
                },
                {
                    key: 'project',
                    label: this.$t('fields.project').toString(),
                    headerTitle: 'Project',
                    sortable: true,
                    thStyle: 'width: 300px;',
                    thClass: 'unselectable text-nowrap columnheader',
                    tdClass: 'datatable-cell text-dark-75 font-size-lg py-2',
                    formatter: null
                },
                {
                    key: 'users',
                    label: this.$t('fields.users').toString(),
                    headerTitle: 'Users',
                    sortable: false,
                    thStyle: 'width: 200px;',
                    thClass: 'unselectable text-nowrap columnheader',
                    tdClass: 'text-nowrap datatable-cell text-dark-75 font-size-lg py-2',
                    formatter: null
                },
                {
                    key: 'isActive',
                    label: this.$t('fields.status').toString(),
                    headerTitle: 'Status',
                    sortable: true,
                    thStyle: 'width: 70px',
                    thClass: 'unselectable text-nowrap columnheader',
                    tdClass: (value: boolean) => { return 'pt-5 pb-4 text-nowrap' + (value ? ' text-success' : ' text-danger'); },
                    formatter: (value: boolean) => { return value ? 'status.active' : 'status.inactive'; }
                },
                {
                    key: 'actions',
                    label: '',
                    headerTitle: '',
                    sortable: false,
                    thStyle: 'width: 80px',
                    thClass: 'columnheader',
                    tdClass: 'pl-1 pr-1 py-4 text-right',
                    formatter: null
                }
            ];
        }

        async loadTasks() {
            //this.isBusy = true;

            try {
                const response = await AxiosService.request<ServerData>({
                    url: `tasksadministration/list`,
                    method: 'POST',
                    data: this.listOptions
                });

                this.tasks = response.data.records ?? [];
                this.listOptions.pagerOptions = InitPagerOptions(response.data.totalRecordCount, response.data.pageCount, this.listOptions.pagerOptions.page, this.listOptions.pagerOptions.pageSize);
            }
            catch (error) {
                if (error.response) {
                    switch (error.response.status) {
                        case 404:
                            return this.$router.push(`/${i18n.locale}/notfound`);
                        case 403:
                            return this.$router.push(`/${i18n.locale}/accessdenied`);
                        default:
                            return this.$router.push(`/${i18n.locale}/error/${error.response.status}`);
                    }
                }
            }
            finally {
                this.isBusy = false;
                this.$emit('load-complete');
            }
        }

        editTask(id: string) {
            this.$emit('task-selected', id);
        }

        async deleteTask(id: string) {
            try {
                const response = await AxiosService.request({
                    url: `tasksadministration/candelete/${id}`,
                    method: 'GET'
                });

                const canDelete = response.data.canDelete;

                const task = this.tasks.find(x => x.id == id);

                if (!canDelete) {
                    this.$bvModal.msgBoxOk(
                        this.$t('modal.deniedTaskDeleteMessage', { taskName: task?.name }) as string, {
                            title: this.$t('modal.deniedTaskDeleteTitle') as string,
                            centered: true,
                            buttonSize: 'sm',
                            okTitle: this.$t('modal.closeModal') as string
                        }
                    );
                    return;
                }

                this.$bvModal.msgBoxConfirm(this.$t('modal.confirmTaskDeleteMessage', { taskName: task?.name }) as string, {
                    title: this.$t('modal.confirmTaskDeleteTitle') as string,
                        centered: true,
                        buttonSize: 'sm',
                        okTitle: this.$t('modal.confirmOkTitle') as string,
                        cancelTitle: this.$t('modal.confirmCancelTitle') as string
                    })
                    .then(value => {
                        if (value) {
                            try {
                                AxiosService.request<ServerData>({
                                    url: `tasksadministration?id=${id}`,
                                    method: 'DELETE'
                                });

                                this.$root.$bvToast.toast(this.$t('toaster.taskDeleted', { taskName: task?.name }) as string, {
                                    title: this.$t('toaster.deleteTaskTitle') as string,
                                    autoHideDelay: Configuration.ToasterAutoHideDelay,
                                    appendToast: true,
                                    variant: Configuration.ToasterVariantSuccess,
                                    toaster: Configuration.ToasterPosition
                                });
                            }
                            catch (error) {
                                if (error.response) {
                                    switch (error.response.status) {
                                        case 404:
                                            return this.$router.push(`/${i18n.locale}/notfound`);
                                        case 403:
                                            return this.$router.push(`/${i18n.locale}/accessdenied`);
                                        default:
                                            return this.$router.push(`/${i18n.locale}/error/${error.response.status}`);
                                    }
                                }
                            }
                            finally {
                                this.isBusy = false;
                            }
                        }
                    })
                    .then(() => {
                        this.refreshList(true);
                    })
                    .catch(error => {
                        console.error(error);
                    });
            }
            catch (error) {
                if (error.response) {
                    switch (error.response.status) {
                        case 404:
                            return this.$router.push(`/${i18n.locale}/notfound`);
                        case 403:
                            return this.$router.push(`/${i18n.locale}/accessdenied`);
                        default:
                            return this.$router.push(`/${i18n.locale}/error/${error.response.status}`);
                    }
                }
            }
            finally {
                this.isBusy = false;
            }
        }

        onChangePage(page: number) {
            this.listOptions.pagerOptions.page = page;
            this.refreshList(true);
        }

        onChangePageSize(pageSize: number) {
            this.listOptions.pagerOptions.pageSize = pageSize;
            this.listOptions.pagerOptions.page = 1;
            this.refreshList(true);
        }

        onSortChanged(e: TableSortEventArgs) {
            this.listOptions.sortOptions.sortBy = e.sortBy;
            this.listOptions.sortOptions.sortDirection = e.sortDesc ? -1 : 1;
            this.refreshList(true);
        }

        onLocaleChanged(locale: string) { // eslint-disable-line @typescript-eslint/no-unused-vars
            this.$nextTick(() => {
                this.initFields();
            });
        }
	}

	interface ServerData {
        records: TaskListItem[];
        totalRecordCount: number;
        pageCount: number;
	}

    interface TaskListItem {
        id: string;
        sequenceId: number;
        name: string;
        project: EntityReference;
        users: EntityReference[];
        isActive: boolean;
        actions: string;
    }

    interface TaskListOptions {
        filter: TaskFilterOptions;
        pagerOptions: PagerOptions;
        sortOptions: SortOptions;
    }
